<template>
  <nav aria-label="breadcrumb" class="hc-breadcrumb" :class="wrapperClass">
    <ol class="breadcrumb">
      <slot />
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'HcBreadcrumb',
  props: {
    wrapperClass: {
      type: String,
      default: '',
    },
  },
};
</script>
